import {
  differenceInDays,
  startOfDay,
  addMinutes,
  addHours,
  endOfDay,
  addDays,
  format,
} from 'date-fns';
import * as fp from 'lodash/fp';
import sortOperatingTime from '~/utils/sortOperatingTime';

import { OperatingTime, PreOrderSetting, Week } from '~/types/common';

export default function getRecentPickMealTime(
  preOrderSetting: PreOrderSetting,
  operatingTime: OperatingTime,
  date: Date,
): {
  at: Date | null;
  end: Date | null;
} {
  const startTime = addHours(date, preOrderSetting.afterHours);
  const endTime = addHours(date, preOrderSetting.beforeHours);

  const sortedOperatingTime = sortOperatingTime(operatingTime);

  const diffDays = differenceInDays(endOfDay(endTime), startOfDay(startTime));

  return fp
    .range(0)(diffDays)
    .reduce<{
      at: Date | null;
      end: Date | null;
    }>(
      (acc, index) => {
        if (fp.isDate(acc.at) && fp.isDate(acc.end)) {
          return acc;
        }
        const checkDate = addDays(startTime, index);

        const week = format(checkDate, 'EEE').toUpperCase() as Week;

        const schedules = sortedOperatingTime[week];

        const schedule = schedules.find(({ start }) => {
          const weekDayStartTime = addMinutes(startOfDay(checkDate), start).getTime();

          return (
            fp.gt(weekDayStartTime, startTime.getTime()) &&
            fp.lte(weekDayStartTime, endTime.getTime())
          );
        });

        if (!schedule) {
          return acc;
        }

        return {
          at: addMinutes(startOfDay(checkDate), schedule.start),
          end: addMinutes(startOfDay(checkDate), schedule.end),
        };
      },
      {
        at: null,
        end: null,
      },
    );
}
